// extracted by mini-css-extract-plugin
module.exports = {"leadership":"leadership_leadership__3O_aI"};